import * as Types from '../../../../baseType';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommentItemFragment = { __typename?: 'ChapterComment', createdAt: any, ccId: number, authorId?: number | null, isHidden: boolean, isSpoiler: boolean, content: string, numOfLikes: number, numOfNestedComments: number, contentEditedAt?: any | null, deletedAt?: any | null, deletedByAdmin: boolean, isBestComment: boolean, likedByMe: boolean, parentId?: number | null, story: { __typename?: 'Story', name: string, storyId: number }, chapter: { __typename?: 'Chapter', name: string, chapterId: number, chapterIndex: number }, author?: { __typename?: 'User', name?: string | null, userId: number } | null };

export type ListChapterCommentQueryVariables = Types.Exact<{
  storyId: Types.Scalars['Int'];
  chapterIndex?: Types.InputMaybe<Types.Scalars['Int']>;
  parentId?: Types.InputMaybe<Types.Scalars['Int']>;
  choiceId?: Types.InputMaybe<Types.Scalars['Int']>;
  page: Types.Scalars['Int'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  exceptHidden?: Types.InputMaybe<Types.Scalars['Boolean']>;
  exceptDeleted?: Types.InputMaybe<Types.Scalars['Boolean']>;
  orderBy?: Types.InputMaybe<Array<Types.ChapterCommentOrderBy> | Types.ChapterCommentOrderBy>;
  onlySystemLanguageMatched?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type ListChapterCommentQuery = { __typename?: 'Query', listChapterCommentV3: { __typename?: 'ListableChapterComment', page: number, totalCount: number, canWriteComment: boolean, list: Array<{ __typename?: 'ChapterComment', createdAt: any, ccId: number, authorId?: number | null, isHidden: boolean, isSpoiler: boolean, content: string, numOfLikes: number, numOfNestedComments: number, contentEditedAt?: any | null, deletedAt?: any | null, deletedByAdmin: boolean, isBestComment: boolean, likedByMe: boolean, parentId?: number | null, story: { __typename?: 'Story', name: string, storyId: number }, chapter: { __typename?: 'Chapter', name: string, chapterId: number, chapterIndex: number }, author?: { __typename?: 'User', name?: string | null, userId: number } | null }> } };

export const CommentItemFragmentDoc = gql`
    fragment CommentItem on ChapterComment {
  createdAt
  ccId
  story {
    name
    storyId
  }
  chapter {
    name
    chapterId
    chapterIndex
  }
  author {
    name
    userId
  }
  authorId
  isHidden
  isSpoiler
  content
  numOfLikes
  numOfNestedComments
  contentEditedAt
  deletedAt
  deletedByAdmin
  isBestComment
  likedByMe
  parentId
}
    `;
export const ListChapterCommentDocument = gql`
    query ListChapterComment($storyId: Int!, $chapterIndex: Int, $parentId: Int, $choiceId: Int, $page: Int!, $pageSize: Int, $exceptHidden: Boolean, $exceptDeleted: Boolean, $orderBy: [ChapterCommentOrderBy!], $onlySystemLanguageMatched: Boolean) {
  listChapterCommentV3(
    data: {storyId: $storyId, chapterIndex: $chapterIndex, parentId: $parentId, choiceId: $choiceId, page: $page, pageSize: $pageSize, exceptHidden: $exceptHidden, exceptDeleted: $exceptDeleted, orderBy: $orderBy, onlySystemLanguageMatched: $onlySystemLanguageMatched}
  ) {
    page
    totalCount
    canWriteComment
    list {
      ...CommentItem
    }
  }
}
    ${CommentItemFragmentDoc}`;

/**
 * __useListChapterCommentQuery__
 *
 * To run a query within a React component, call `useListChapterCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChapterCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChapterCommentQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      chapterIndex: // value for 'chapterIndex'
 *      parentId: // value for 'parentId'
 *      choiceId: // value for 'choiceId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      exceptHidden: // value for 'exceptHidden'
 *      exceptDeleted: // value for 'exceptDeleted'
 *      orderBy: // value for 'orderBy'
 *      onlySystemLanguageMatched: // value for 'onlySystemLanguageMatched'
 *   },
 * });
 */
export function useListChapterCommentQuery(baseOptions: Apollo.QueryHookOptions<ListChapterCommentQuery, ListChapterCommentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListChapterCommentQuery, ListChapterCommentQueryVariables>(ListChapterCommentDocument, options);
      }
export function useListChapterCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListChapterCommentQuery, ListChapterCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListChapterCommentQuery, ListChapterCommentQueryVariables>(ListChapterCommentDocument, options);
        }
export type ListChapterCommentQueryHookResult = ReturnType<typeof useListChapterCommentQuery>;
export type ListChapterCommentLazyQueryHookResult = ReturnType<typeof useListChapterCommentLazyQuery>;
export type ListChapterCommentQueryResult = Apollo.QueryResult<ListChapterCommentQuery, ListChapterCommentQueryVariables>;